import { useEffect, useState } from 'react';
import { AlertTriangle, RefreshCw, ExternalLink } from 'lucide-react';
import { ModalPanel, Button } from '@/contasis';
import { planVencidoBridge } from '@/services/api/plan-vencido-bridge';
import type { CasoPlanVencido } from '@/services/api/plan-vencido-bridge';
import { construirUrlSuscripcion } from '@/utils/enlacesBilling';
import { storageService } from '@/utils/storage';
import { useSuscripcion } from '@/hooks/useSuscripcion';

export const ModalPlanVencido = () => {
  const [caso, setCaso] = useState<CasoPlanVencido | null>(null);
  const suscripcion = useSuscripcion();

  useEffect(() => {
    planVencidoBridge.register(setCaso);
  }, []);

  if (!caso) return null;

  const esTrial = caso === 'trial';
  const urlSuscripcion = construirUrlSuscripcion(storageService.getEmpresaId(), {
    planSku: suscripcion?.planSku ?? undefined,
  });

  return (
    <ModalPanel
      isOpen
      title={esTrial ? 'Tu prueba venció' : 'Tu plan venció'}
      subtitle="Puedes seguir viendo tus registros, pero no crear ni editar información"
      size="medium"
      onClose={() => setCaso(null)}
      footerActions={
        <Button
          variant="primary"
          size="sm"
          icon={<RefreshCw className="w-4 h-4" />}
          onClick={() => window.open(urlSuscripcion, '_blank')}
        >
          {esTrial ? 'Activar plan' : 'Renovar'}
        </Button>
      }
    >
      <div className="px-6 py-8 flex flex-col items-center text-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-error-bg flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-error" />
        </div>
        <div className="space-y-1.5 max-w-sm">
          <h3 className="font-display text-h5 text-primary">
            {esTrial ? 'Activa un plan para seguir creando' : 'Renueva tu suscripción'}
          </h3>
          <p className="text-ui-sm text-secondary">
            {esTrial
              ? 'Tu período de prueba terminó. Activa un plan para volver a crear y editar comprobantes, productos y demás registros.'
              : 'Tu suscripción venció. Renueva tu plan para volver a crear y editar comprobantes, productos y demás registros.'}
          </p>
        </div>
        <p className="text-caption text-tertiary flex items-center gap-1.5">
          <ExternalLink className="w-3.5 h-3.5" />
          Te lleva a Senciyo Billing, donde se gestiona tu suscripción
        </p>
      </div>
    </ModalPanel>
  );
};
